import { io } from "socket.io-client";
import { UserRole } from "@/models/user.generalkey";
import { apiConfig } from "@/config/baseUrl";
class SocketService {
    constructor() {
        this.socket = null;
        this.restaurantId = null;
        this.userRole = null;
        this.userRole = localStorage.getItem("USER_ROLE");
        this.restaurantId = localStorage.getItem("USER_RESTAURANT_ID");
    }
    connect() {
        if (this.socket?.connected) {
            return;
        }
        const wssUrl = apiConfig.wssURL;
        this.socket = io(wssUrl, {
            transports: ["websocket", "polling"],
            autoConnect: true,
            reconnection: true,
            reconnectionDelay: 1000,
            reconnectionAttempts: 5,
            timeout: 20000,
        });
        this.setupEventListeners();
    }
    setupEventListeners() {
        if (!this.socket)
            return;
        this.socket.on("connect", () => {
            if (this.userRole === UserRole.RESTAURANT && this.restaurantId) {
                this.joinRestaurant(this.restaurantId);
            }
        });
        this.socket.on("disconnect", () => { });
        this.socket.on("connect_error", (error) => {
            console.error("Erreur de connexion WebSocket:", error);
        });
        this.socket.on("new-order", (data) => {
            this.handleNewOrder(data);
        });
        this.socket.on("order-status-changed", (data) => {
            this.handleOrderStatusChange(data);
        });
        this.socket.on("new-order-global", (data) => {
            if (this.userRole === UserRole.FRANCHISE) {
                this.handleGlobalOrder(data);
            }
        });
    }
    joinRestaurant(restaurantId) {
        if (this.socket?.connected) {
            this.socket.emit("join-restaurant", { restaurantId });
            this.restaurantId = restaurantId;
        }
    }
    leaveRestaurant(restaurantId) {
        if (this.socket?.connected) {
            this.socket.emit("leave-restaurant", { restaurantId });
        }
    }
    handleNewOrder(data) {
        if (this.userRole === UserRole.RESTAURANT && this.restaurantId) {
            if (data?.restaurantId !== this.restaurantId) {
                return;
            }
        }
        if (this.userRole !== UserRole.RESTAURANT) {
            return;
        }
        this.playNotificationSound();
        window.dispatchEvent(new CustomEvent("new-order-modal", {
            detail: {
                transactionReference: data?.order?.transactionReference || "N/A",
                order: data?.order,
            },
        }));
        this.showNotification(`Nouvelle commande #${data?.order?.transactionReference || "N/A"}`, {
            body: `${data?.order?.customer?.first_name || "Client"} - ${data?.order?.total || 0} CHF`,
            icon: "/favicon.ico",
            tag: `order-${data?.order?.transactionReference}`,
            requireInteraction: true,
        });
        window.dispatchEvent(new CustomEvent("new-order-received", {
            detail: data,
        }));
    }
    handleOrderStatusChange(data) {
        if (this.userRole === UserRole.RESTAURANT && this.restaurantId) {
            if (data.order?.restaurantId !== this.restaurantId) {
                return;
            }
        }
        window.dispatchEvent(new CustomEvent("order-status-changed", {
            detail: data,
        }));
    }
    handleGlobalOrder(data) {
        this.playNotificationSound();
        window.dispatchEvent(new CustomEvent("global-order-toast", {
            detail: {
                message: "Nouvelle commande dans un restaurant",
            },
        }));
    }
    playNotificationSound() {
        try {
            const audioContext = new (window.AudioContext ||
                window.webkitAudioContext)();
            const oscillator = audioContext.createOscillator();
            const gainNode = audioContext.createGain();
            oscillator.connect(gainNode);
            gainNode.connect(audioContext.destination);
            oscillator.frequency.setValueAtTime(800, audioContext.currentTime);
            oscillator.frequency.setValueAtTime(600, audioContext.currentTime + 0.1);
            gainNode.gain.setValueAtTime(2.0, audioContext.currentTime);
            gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.2);
            oscillator.start(audioContext.currentTime);
            oscillator.stop(audioContext.currentTime + 0.2);
        }
        catch (error) {
            console.error("Impossible de jouer le son de notification:", error);
        }
    }
    showNotification(title, options) {
        if ("Notification" in window) {
            if (Notification.permission === "granted") {
                new Notification(title, options);
            }
            else if (Notification.permission !== "denied") {
                Notification.requestPermission().then((permission) => {
                    if (permission === "granted") {
                        new Notification(title, options);
                    }
                });
            }
        }
    }
    disconnect() {
        if (this.socket) {
            this.socket.disconnect();
            this.socket = null;
        }
    }
    isConnected() {
        return this.socket?.connected || false;
    }
    getSocketId() {
        return this.socket?.id;
    }
}
const socketService = new SocketService();
export default socketService;
